<template>
	<section class="switch_wrap">
		<div @click="toggle" :class="{ active: SwitchIsActive, disable: !isEnable }" class="switch" :data-tracking-id="dtmTitle" data-tracking-label="onoff">
			<div class="switch_trigger" :class="{ active: SwitchIsActive, disable: !isEnable }">
				<svg :class="SwitchIsActive ? svg : 'icon-close'">
					<use :xlink:href="`#${SwitchIsActive ? svg : 'icon-close'}`" />
				</svg>
			</div>

			<ul>
				<template v-if="country === 'germany'">
					<li>An</li>
					<li>Aus</li>
				</template>
				<template v-else>
					<li>on</li>
					<li>off</li>
				</template>
			</ul>
		</div>
		<p class="switch-title">{{ title }}</p>
	</section>
</template>
<script>
import { mapState } from "vuex";
import Lightbox from "@/components/shared/LightBox";
export default {
	props: {
		active: Boolean,
		title: String,
		svg: String,
		dtmTitle: String,
		isEnable: {
			type: Boolean,
			required: false,
			default: true,
		},
	},
	data() {
		return {
			SwitchIsActive: this.active,
			lightboxVisible: false,
            lang2: null
		};
	},
	components: {
		Lightbox,
	},
    mounted () {
        this.getCountryCode();
    },
	computed: {
		...mapState({
			country: (state) => state.country,
            lang: (state) => state.lang,
		}),
	},
	watch: {
		active: function() {
			this.SwitchIsActive = this.active;
		},
	},
	methods: {
        getCountryCode() {
            let countryCodes = [
                {
                    key: 'france',
                    value: 'FR'
                },
                {
                    key: 'italy',
                    value: 'IT'
                },
                {
                    key: 'uk',
                    value: 'EN'
                },
                {
                    key: 'germany',
                    value: 'DE'
                },
                {
                    key: 'switzerland',
                    value: 'CH'
                },
                {
                    key: 'austria',
                    value: 'AT'
                },
                {
                    key: 'belgium',
                    value: 'BE'
                },
                {
                    key: 'luxembourg',
                    value: 'LU'
                },
                {
                    key: 'netherlands',
                    value: 'NL'
                },
                {
                    key: 'poland',
                    value: 'PL'
                },
                {
                    key: 'ukraine',
                    value: 'UA'
                },
                {
                    key: 'denmark',
                    value: 'DK'
                },
                {
                    key: 'sweden',
                    value: 'SE'
                },
                {
                    key: 'norge',
                    value: 'NO'
                },
                {
                    key: 'finland',
                    value: 'FI'
                },
                {
                    key: 'estonia',
                    value: 'EE'
                },
                {
                    key: 'lithuania',
                    value: 'LT'
                },
                {
                    key: 'latvia',
                    value: 'LV'
                },
                {
                    key: 'spain',
                    value: 'ES'
                },
                {
                    key: 'portugal',
                    value: 'PT'
                },
                {
                    key: 'russia',
                    value: 'RU'
                },
            ]
            this.lang2 =  countryCodes.filter(obj => obj.key == this.country)
        },
		togglePopin() {
			this.lightboxVisible = !this.lightboxVisible;
		},
        toggle() {
            let languageCode = this.lang === 'fr_FR' ? 'fr' : (this.lang === 'en_uk' ? 'en' : this.lang)
			dataLayer = [];
			dataLayer.toggleType = `FS ${this.lang2[0].value}_${languageCode} FS e-4ORCE ON-OFF`;
            dataLayer.toggleValue = this.SwitchIsActive === false ? "ON" : "OFF";
			window._satellite.track("toggle");
			this.SwitchIsActive = !this.SwitchIsActive;
			// Emit the object list to the parent div
			this.$emit("event_parent", this.SwitchIsActive);
		},
	},
};
</script>
